// useAvaliacoesRecentes.js — Avaliações recentes do site inteiro (carrossel da home).
//
// GET {API}avaliacoes-recentes?limit=24  (público)
//   → { avaliacoes: [{ id, nota, comentario, usuario_nome, created_at,
//                      livro: { id, titulo, image } }], total }
//
// Cache de módulo pelo mesmo motivo do useHomeConfig: a home monta várias
// seções e o React em StrictMode monta cada componente duas vezes em
// desenvolvimento. Sem cache, a mesma lista seria buscada de novo a cada
// remontagem, contra uma API que roda num MySQL com limite de conexões.
import { useState, useEffect } from "react";

const API_URL = process.env.REACT_APP_API;

let cache = null;
let promessaEmVoo = null;

const buscar = (limite) => {
  if (cache) return Promise.resolve(cache);
  if (promessaEmVoo) return promessaEmVoo;

  promessaEmVoo = fetch(`${API_URL}avaliacoes-recentes?limit=${limite}`)
    .then((r) => (r.ok ? r.json() : { avaliacoes: [] }))
    .then((d) => {
      cache = Array.isArray(d?.avaliacoes) ? d.avaliacoes : [];
      return cache;
    })
    .catch(() => {
      // Rede fora → lista vazia, e a seção some. Uma faixa quebrada no meio da
      // home é pior do que faixa nenhuma.
      cache = [];
      return cache;
    })
    .finally(() => {
      promessaEmVoo = null;
    });

  return promessaEmVoo;
};

const useAvaliacoesRecentes = (limite = 24) => {
  const [avaliacoes, setAvaliacoes] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    let ativo = true;
    buscar(limite).then((lista) => {
      if (!ativo) return;
      setAvaliacoes(lista);
      setLoading(false);
    });
    return () => {
      ativo = false;
    };
  }, [limite]);

  return { avaliacoes, loading };
};

export default useAvaliacoesRecentes;
